import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { AppContext } from '@/contexts/AppContext';
import { getHttpResponse } from '@/api/helper';
/** @typedef {import("@/types/Company").PinCashCardResponse} PinCashCardResponse  */
const useGetPinCashCardQuery = ( companyId) => {
  const {  token, providerId, userId} = useContext(AppContext);
   /** @type {()=>Promise<import("axios").AxiosResponse<PinCashCardResponse ,any>>} */
  const fetchFn = () =>{
    return getHttpResponse(`client-service/pin-cash-card?providerId=${providerId}&companyId=${companyId}`, token, userId )
  }

 
  return useQuery({
    queryKey: ['pin-cash-card', userId, companyId, providerId],
    staleTime: 300,
    enabled: !!companyId && !!providerId,
    refetchOnWindowFocus:false,
    queryFn: fetchFn
  });
};

export default useGetPinCashCardQuery;